import { formatCurrency } from './CurrencyHelpers.js';
import { minutesToDuration } from './DateTime.js';

export const renewalPeriodOptions = {
    'month-1': 'Monthly',
    'month-2': 'Every other month',
    'month-3': 'Every 3 months',
    'week-1': 'Weekly',
    'week-2': 'Every other week',
    'week-4': 'Every four weeks',
    'year-1': 'Yearly',
};

export const PackageTypes = {
    PACKAGE: 'package',
    SUBSCRIPTION: 'subscription',
    GIFT_CERTIFICATE: 'giftcertificate',
};

export const PackageTypeWords = {
    [PackageTypes.PACKAGE]: {
        singular: 'package',
        plural: 'packages',
    },
    [PackageTypes.SUBSCRIPTION]: {
        singular: 'subscription',
        plural: 'subscriptions',
    },
    [PackageTypes.GIFT_CERTIFICATE]: {
        singular: 'gift certificate',
        plural: 'gift certificates',
    },
};

export function humanRenewalPeriod(period) {
    return renewalPeriodOptions[period];
}

export function humanRedeemableAmount(type, amount) {
    if (type === 'unlimited') {
        return 'unlimited';
    }

    if (type === 'price') {
        return formatCurrency(amount || 0);
    }
    if (type === 'minutes') {
        return minutesToDuration(amount || 0);
    }
    if (type === 'events' || type === 'specific') {
        return `${amount} event${amount !== 1 ? 's' : ''}`;
    }

    return amount || 0;
}

export function hasDiscounts(p) {
    return p?.subscription_settings?.discount?.length > 0;
}

export function humanGrantRedeemableAmount(grant, eventTypes) {
    if (grant?.redeemable_for?.type === 'nothing') {
        if (hasDiscounts(grant?.package)) {
            return 'discount only';
        } else {
            return 'nothing';
        }
    }

    if (
        !eventTypes ||
        grant?.redeemable_for?.type !== 'specific' ||
        !grant?.specific_remaining_balance
    ) {
        return humanRedeemableAmount(
            grant?.redeemable_for?.type,
            grant.remaining_balance,
        );
    } else {
        // We have types and it's redeemable for a specific amount
        let redeemable = '';
        for (const eventTypeId in grant.specific_remaining_balance) {
            const eventType = eventTypes.find(
                et => parseInt(et.id) === parseInt(eventTypeId),
            );

            if (eventType) {
                if (redeemable) {
                    redeemable += ', ';
                }

                redeemable +=
                    grant.specific_remaining_balance[eventTypeId] +
                    ' ' +
                    eventType?.name;
            }
        }

        return redeemable;
    }
}
